import(/* webpackMode: "eager" */ "/app/apps/galatea-web/src/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageChangeProvider"] */ "/app/apps/galatea-web/src/components/LanguageChangeProvider.tsx");
